import { cn } from "@scribenote/brian-design-system";
import {
  boardChrome,
  ClipboardClip,
  sheetSurface,
} from "@scribenote/brian-design-system/internal/clipboardChrome";
import type { ReactNode } from "react";

export interface AuthClipboardProps {
  children: ReactNode;
}

/**
 * The clinic sign-in clipboard: a full-viewport desk with a clipboard lying on
 * it, holding the one paper sheet both auth screens write on. This is the
 * clipboard as a standing page composition, not the kit's modal takeover -
 * the board and clip themselves come from the kit's clipboardChrome, so the
 * physical recipe lives once. Children render on the sheet.
 */
export const AuthClipboard = ({ children }: AuthClipboardProps) => (
  <div className="flex min-h-dvh bg-desk px-4 py-8 font-body text-ink sm:py-12">
    {/* m-auto centers the board and still lets a short viewport scroll it. */}
    <div className={cn("m-auto w-full max-w-md", boardChrome("lg"))}>
      {/* The sheet: the paper the screen writes on. Top padding leaves room
          for the clip's jaw overlapping the paper's top edge. */}
      <div className={cn(sheetSurface, "px-5 pb-7 pt-10 sm:px-8 sm:pb-8")}>
        {children}
      </div>

      <ClipboardClip scale="lg" />
    </div>
  </div>
);
